import api from "./api";

// Get all course categories
export const getCategories = () => api.get("/api/courses/categories");

const categoryApi = {
  getCategories,
};

export default categoryApi;
